// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/account/v1/get_my_vision_preferences.proto (package protos.vision.account.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { VisionPreferences } from "./vision_preferences_pb";
import { file_vision_account_v1_vision_preferences } from "./vision_preferences_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/account/v1/get_my_vision_preferences.proto.
 */
export const file_vision_account_v1_get_my_vision_preferences: GenFile = /*@__PURE__*/
  fileDesc("CjF2aXNpb24vYWNjb3VudC92MS9nZXRfbXlfdmlzaW9uX3ByZWZlcmVuY2VzLnByb3RvEhhwcm90b3MudmlzaW9uLmFjY291bnQudjEieQodR2V0TXlWaXNpb25QcmVmZXJlbmNlc1JlcXVlc3QSTgoGcGFyYW1zGAEgASgLMj4ucHJvdG9zLnZpc2lvbi5hY2NvdW50LnYxLkdldE15VmlzaW9uUHJlZmVyZW5jZXNSZXF1ZXN0LlBhcmFtcxoICgZQYXJhbXMivQEKHkdldE15VmlzaW9uUHJlZmVyZW5jZXNSZXNwb25zZRJPCgZyZXN1bHQYASABKAsyPy5wcm90b3MudmlzaW9uLmFjY291bnQudjEuR2V0TXlWaXNpb25QcmVmZXJlbmNlc1Jlc3BvbnNlLlJlc3VsdBpKCgZSZXN1bHQSQAoLcHJlZmVyZW5jZXMYASABKAsyKy5wcm90b3MudmlzaW9uLmFjY291bnQudjEuVmlzaW9uUHJlZmVyZW5jZXNiBnByb3RvMw", [file_vision_account_v1_vision_preferences]);

/**
 * @generated from message protos.vision.account.v1.GetMyVisionPreferencesRequest
 */
export type GetMyVisionPreferencesRequest = Message<"protos.vision.account.v1.GetMyVisionPreferencesRequest"> & {
  /**
   * @generated from field: protos.vision.account.v1.GetMyVisionPreferencesRequest.Params params = 1;
   */
  params?: GetMyVisionPreferencesRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.account.v1.GetMyVisionPreferencesRequest.
 * Use `create(GetMyVisionPreferencesRequestSchema)` to create a new message.
 */
export const GetMyVisionPreferencesRequestSchema: GenMessage<GetMyVisionPreferencesRequest> = /*@__PURE__*/
  messageDesc(file_vision_account_v1_get_my_vision_preferences, 0);

/**
 * @generated from message protos.vision.account.v1.GetMyVisionPreferencesRequest.Params
 */
export type GetMyVisionPreferencesRequest_Params = Message<"protos.vision.account.v1.GetMyVisionPreferencesRequest.Params"> & {
};

/**
 * Describes the message protos.vision.account.v1.GetMyVisionPreferencesRequest.Params.
 * Use `create(GetMyVisionPreferencesRequest_ParamsSchema)` to create a new message.
 */
export const GetMyVisionPreferencesRequest_ParamsSchema: GenMessage<GetMyVisionPreferencesRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_account_v1_get_my_vision_preferences, 0, 0);

/**
 * @generated from message protos.vision.account.v1.GetMyVisionPreferencesResponse
 */
export type GetMyVisionPreferencesResponse = Message<"protos.vision.account.v1.GetMyVisionPreferencesResponse"> & {
  /**
   * @generated from field: protos.vision.account.v1.GetMyVisionPreferencesResponse.Result result = 1;
   */
  result?: GetMyVisionPreferencesResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.account.v1.GetMyVisionPreferencesResponse.
 * Use `create(GetMyVisionPreferencesResponseSchema)` to create a new message.
 */
export const GetMyVisionPreferencesResponseSchema: GenMessage<GetMyVisionPreferencesResponse> = /*@__PURE__*/
  messageDesc(file_vision_account_v1_get_my_vision_preferences, 1);

/**
 * @generated from message protos.vision.account.v1.GetMyVisionPreferencesResponse.Result
 */
export type GetMyVisionPreferencesResponse_Result = Message<"protos.vision.account.v1.GetMyVisionPreferencesResponse.Result"> & {
  /**
   * @generated from field: protos.vision.account.v1.VisionPreferences preferences = 1;
   */
  preferences?: VisionPreferences | undefined;
};

/**
 * Describes the message protos.vision.account.v1.GetMyVisionPreferencesResponse.Result.
 * Use `create(GetMyVisionPreferencesResponse_ResultSchema)` to create a new message.
 */
export const GetMyVisionPreferencesResponse_ResultSchema: GenMessage<GetMyVisionPreferencesResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_account_v1_get_my_vision_preferences, 1, 0);

